import { render, staticRenderFns } from "./ActivateWalletNew.vue?vue&type=template&id=0c3211da&scoped=true"
import script from "./ActivateWalletNew.vue?vue&type=script&lang=js"
export * from "./ActivateWalletNew.vue?vue&type=script&lang=js"
import style0 from "./ActivateWalletNew.vue?vue&type=style&index=0&id=0c3211da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3211da",
  null
  
)

export default component.exports